__turbopack_context__.v({
  "arrow": "PZbXta_arrow",
  "banner": "PZbXta_banner",
  "copy": "PZbXta_copy",
  "cta": "PZbXta_cta",
  "shader": "PZbXta_shader",
  "sub": "PZbXta_sub",
  "title": "PZbXta_title",
  "wrap": "PZbXta_wrap",
});
